var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-index"},[_c(_vm.componentName,{tag:"component",attrs:{"vipData":_vm.vipData,"userInfo":_vm.userInfo},on:{"refresh":_vm.getVipData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }